var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shrink",style:({maxWidth:'130px'})},[_c('user-combobox',{attrs:{"role-names":['repartidor','repartidorTercerizado'],"hide-details":"","dense":"","clearable":_vm.clearable,"disabled":_vm.disabled},on:{"input":_vm.updateDeliveryUser},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }